import _toConsumableArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';

function useQueue(_ref) {
  var _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? [] : _ref$initialValues,
      limit = _ref.limit;

  var _useState = useState({
    state: initialValues.slice(0, limit),
    queue: initialValues.slice(limit)
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      state = _useState2$.state,
      queue = _useState2$.queue,
      setState = _useState2[1];

  var add = function add() {
    for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
      items[_key] = arguments[_key];
    }

    return setState(function (current) {
      var results = [].concat(_toConsumableArray(current.state), _toConsumableArray(current.queue), items);
      return {
        state: results.slice(0, limit),
        queue: results.slice(limit)
      };
    });
  };

  var update = function update(fn) {
    return setState(function (current) {
      var results = fn([].concat(_toConsumableArray(current.state), _toConsumableArray(current.queue)));
      return {
        state: results.slice(0, limit),
        queue: results.slice(limit)
      };
    });
  };

  var cleanQueue = function cleanQueue() {
    return setState(function (current) {
      return {
        state: current.state,
        queue: []
      };
    });
  };

  return {
    state: state,
    queue: queue,
    add: add,
    update: update,
    cleanQueue: cleanQueue
  };
}

export { useQueue };